export interface IPaginatedData<T> {
  totalCount: number;
  page: number;
  pageSize: number;
  items: T[];
}
